import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { ImageMetadata } from "../../../_objects/image-metadata";
import { ImageMetadataProperty } from "../../../_objects/image-metadata-property";
import { DISPLAYED_METADATA_KEYS } from "./displayed-metadata-keys";

/** One row of the Metadata section: the name of an `exifreader` tag and the raw value of the tag. */
export interface MetadataRow {
  key: string;
  value: ImageMetadataProperty["value"];
}

@Component({
  selector: "app-image-metadata-card",
  templateUrl: "./image-metadata-card.component.html",
  styleUrl: "./image-metadata-card.component.scss",
  standalone: false
})
export class ImageMetadataCardComponent implements OnChanges {
  @Input() imageMetadata: ImageMetadata | null;
  @Input() properties: { key: string; value: string }[];

  /** The tags of the image listed in `DISPLAYED_METADATA_KEYS`, sorted by name. Empty when the image has none of them. */
  metadataRows: MetadataRow[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.imageMetadata) {
      this.metadataRows = this.toMetadataRows(this.imageMetadata);
    }
  }

  private toMetadataRows(imageMetadata: ImageMetadata | null): MetadataRow[] {
    if (!imageMetadata?.metadata) {
      return [];
    }

    return [...imageMetadata.metadata]
      .filter(([key]) => DISPLAYED_METADATA_KEYS.has(key))
      .map(([key, property]) => ({ key, value: property.value }))
      .sort((a, b) => a.key.localeCompare(b.key));
  }
}
